import axios from './axios';
const OSS = require('ali-oss');
const acl = "public-read"

async function getSts(gameId) {
    return axios({
        url: `/oss/getOssConfig/${gameId}`,
        method: 'get',
        headers: {
            token : localStorage.getItem('web_token')
        }
    })
}

function getStsConfig() {
    return axios({
        url: `/oss/getStsConfig`,
        method: 'get',
        headers: {
            token : localStorage.getItem('web_token')
        }
    })
}

export async function commonUpload(item, filePathCallback) {
    try {
        let res = {};
        let path = "";
        if(item.data.gameId) {
            res = await getSts(item.data.gameId);
            path = filePathCallback({name: res.data.data.name, shortName: res.data.data.shortName});
        }else {
            res = await getStsConfig();
            path = filePathCallback();
        }
        const client = new OSS({
            region: res.data.data.region,
            authorizationV4: true,
            accessKeyId: res.data.data.accessId,
            accessKeySecret: res.data.data.accessKey,
            stsToken: res.data.data.sessionToken,
            bucket: res.data.data.bucket,
        });
        // 上传文件名称
        let filename = item.file.name
        let pos = filename.lastIndexOf('.')
        let suffix = ''
        //获取尾缀
        if (pos !== -1) suffix = filename.substring(pos)
        // let path = folder + "/" + res.data.data.name + "/" + res.data.data.shortName + suffix;
        await client.put(path + suffix, item.file, {
            headers: {
                "Content-Type": item.file.type,
                'x-oss-object-acl': acl,
                'Access-Control-Allow-Credentials': true,
            }
        });
        return {
            success: true,
            response: { url: res.data.data.prefixUrl, path: path + suffix}
        }
    }catch (e) {
        console.error("上传失败", e);
        return {
            success: false,
            error: '上传失败',
            response: {},
        }
    }
}

export async function chunkedUpload(item, filePathCallback) {
    try {
        let res = {};
        let path = "";
        if(item.data.gameId) {
            res = await getSts(item.data.gameId);
            path = filePathCallback({name: res.data.data.name, shortName: res.data.data.shortName});
        }else {
            res = await getStsConfig();
            path = filePathCallback();
        }
        let data = res.data.data;

        const client = new OSS({
            region: data.region,
            authorizationV4: true,
            accessKeyId: data.accessId,
            accessKeySecret: data.accessKey,
            stsToken: data.sessionToken,
            bucket: data.bucket,
        });
        // 上传文件名称
        let filename = item.file.name
        let pos = filename.lastIndexOf('.')
        let suffix = ''
        //获取尾缀
        if (pos !== -1) suffix = filename.substring(pos)
        // let path = folder + "/" + data.name + "/" + data.shortName + suffix;
        await client.multipartUpload(path + suffix, item.file, {
            // 获取分片上传进度、断点和返回值。
            progress: (p, cpt, res) => {
                //已经上传的百分比
                item.data.progress = Math.floor(100 * p);
            },
            // 设置并发上传的分片数量。
            parallel: 4,
            // 设置分片大小。默认值为1 MB，最小值为100 KB，最大值为5 GB。最后一个分片的大小允许小于100 KB。
            partSize: 10 * 1024 * 1024,
            headers: {
                "Content-Type": item.file.type,
                'x-oss-object-acl': acl,
                'Access-Control-Allow-Credentials': true,
                "x-oss-forbid-overwrite": false,
            }
        })
        return {
            success: true,
            response: { url: '', path: path + suffix}
        }
    }catch (e) {
        console.error("上传失败", e);
        return {
            success: false,
            error: '上传失败',
            response: {},
        }
    }
}